import { useFormikContext } from 'formik';
import ErrorMessage from '../ErrorMessage/ErrorMessage';
import './SelectFormField.css';

interface FormFieldProps {
  name: string;
  options: { value: string; label: string }[]; // An array of options for the select dropdown
  placeholder?: string;
}

function SelectFormField({ name, options, placeholder }: FormFieldProps) {
  const { setFieldTouched, setFieldValue, errors, touched, values }: any = useFormikContext();

  return (
    <>
      <select
      className="custom-select"
        onBlur={() => setFieldTouched(name)}
        onChange={(e) => setFieldValue(name, e.target.value)}
        value={values[name]}
        name={name}
      >
        {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <ErrorMessage error={errors[name]} visible={touched[name]}/>
    </>
  );
}

export default SelectFormField;